var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-8"},[_c(_vm.$store.state.calculators.calculator,{tag:"component"})],1),_vm._v(" "),_c('Navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }